import { FeatureFlagConfig } from "@fidelix/fx-miranda";

export const featureFlags = new FeatureFlagConfig({
  "IP Settings": ["dev", "localhost"],
  "Device-IP-Validation": ["dev", "localhost"],
  "External-Device": [],
});
